import styles from '../../css/AnalysisToggle.module.css';

export default function AnalysisToggle({
  state,
  setState,
  handleAreaSelect,
  sectorData
}) {
  

  const guHandler = (e, center) => {
    setState({ ...state, gu: e.target.value })

    if(state.gu.length > 0 || state.gu !== e.target.value){
      setState({...state, toggleGu: false, gu:e.target.value})
    }

    handleAreaSelect(e.target.value, center);
  }

  const dbClickEvent = () => {
    setState({...state, gu:[], toggleGu: true});
    handleAreaSelect('', '');
  }

  return (
    <div className={`${styles.container} ${styles.guContainer}`}>
      <div className={styles.toggleSelectArea}>
        <ul className={styles.toggleSelect}>
          {
            sectorData.map((menu, code) => (
              <li key={code} onDoubleClick={dbClickEvent}>
                <input type='radio'
                  name='gu'
                  className='radioSel'
                  value={menu.value}
                  id={menu.code}
                  onChange={(e) => guHandler(e, menu.icon)}
                  checked={state.gu === menu.value}
                  
                  // checked={sectorData.includes(menu.value)}
                />
                <label htmlFor={menu.code}
                  className='radioSel'>
                  {menu.value}
                </label>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  )
}